import React from "react";

/**
 * GoldDisplay — mostra saldo de gold com icone de moeda.
 */
class GoldDisplay extends React.Component {
  render() {
    var balance = parseInt(this.props.balance) || 0;
    var compact = this.props.compact;
    var size = compact ? '0.85rem' : '1.1rem';

    return (
      <div style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
        borderRadius: '20px',
        padding: compact ? '3px 10px' : '5px 14px',
        color: '#fff',
        fontWeight: 700,
        fontSize: size,
        boxShadow: '0 2px 6px rgba(255,165,0,0.4)',
        textShadow: '0 1px 2px rgba(0,0,0,0.2)'
      }}>
        <i className="fas fa-coins" />
        <span>{balance.toLocaleString('pt-BR')}</span>
      </div>
    );
  }
}

export default GoldDisplay;
